import React, { createContext, useContext, useState } from "react";

const PackagePaymentModalContext = createContext(null);

export const PackagePaymentModalProvider = ({ children }) => {
	const [modalState, setModalState] = useState({
		open: false,
		bookingTransactionId: null,
		totalPaid: 0,
		currency: "BRL",
		title: "",
		onSuccess: null,
	});

	const openPaymentModal = ({ bookingTransactionId, totalPaid, currency, title, onSuccess }) => {
		setModalState({ open: true, bookingTransactionId, totalPaid, currency: currency || "BRL", title: title || "", onSuccess: onSuccess || null });
	};

	const closePaymentModal = () => {
		setModalState((prev) => ({ ...prev, open: false }));
	};

	return (
		<PackagePaymentModalContext.Provider value={{ modalState, openPaymentModal, closePaymentModal }}>
			{children}
		</PackagePaymentModalContext.Provider>
	);
};

export const usePackagePaymentModalContext = () => {
	const ctx = useContext(PackagePaymentModalContext);
	if (!ctx) throw new Error("usePackagePaymentModalContext deve ser usado dentro de PackagePaymentModalProvider");
	return ctx;
};
